import { Menu } from '@base-ui/react/menu';

import { useUserAccount } from './use-user-account';
import { UserAccountContent } from './user-account-content';
import { UserDropdownTrigger } from './user-dropdown-trigger';
import { DropdownCard, DropdownPositioner } from './UserDropdown.styled';

export const UserDropdown = () => {
  const data = useUserAccount();
  const { open, setOpen, user, headshotFile, roleConfig, badgeLabel } = data;

  return (
    <Menu.Root open={open} onOpenChange={setOpen}>
      <Menu.Trigger
        render={(props) => (
          <UserDropdownTrigger
            {...props}
            email={user?.email || ''}
            userName={user?.name || undefined}
            headshotUrl={headshotFile?.url}
            headshotName={headshotFile?.fileName}
            badgeLabel={badgeLabel}
            badgeColor={roleConfig.color}
          />
        )}
      />

      <Menu.Portal>
        <DropdownPositioner side="bottom" align="end" sideOffset={8}>
          <Menu.Popup render={<DropdownCard />}>
            <UserAccountContent data={data} />
          </Menu.Popup>
        </DropdownPositioner>
      </Menu.Portal>
    </Menu.Root>
  );
};
